import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Box,
} from "@mui/material";

interface AllItemsDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  items: Array<Record<string, string | null>>;
  fieldLabels: Record<string, string>;
  isLoading?: boolean;
}

/**
 * 全件表示ダイアログ
 */
export const AllItemsDialog = ({
  open,
  onClose,
  title,
  items,
  fieldLabels,
  isLoading = false,
}: AllItemsDialogProps): JSX.Element => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {isLoading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: 200,
            }}
          >
            <CircularProgress />
          </Box>
        ) : items.length === 0 ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            対象のデータはありません
          </Box>
        ) : (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "primary.main" }}>
                  {Object.values(fieldLabels).map((label, index) => (
                    <TableCell
                      key={`${label}-${index}`}
                      sx={{
                        fontWeight: "bold",
                        color: "#FFFFFF",
                      }}
                    >
                      {label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {items.map((item, index) => (
                  <TableRow key={index}>
                    {Object.keys(fieldLabels).map((fieldKey) => (
                      <TableCell key={`${fieldKey}-${index}`}>
                        {item[fieldKey]?.length ? item[fieldKey] : "-"}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  );
};
